import { render, staticRenderFns } from "./myPost.vue?vue&type=template&id=4b278904&scoped=true"
import script from "./myPost.vue?vue&type=script&lang=js"
export * from "./myPost.vue?vue&type=script&lang=js"
import style0 from "./myPost.vue?vue&type=style&index=0&id=4b278904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b278904",
  null
  
)

export default component.exports